module.exports = __webpack_public_path__ + "static/media/sibasis.4f9bca36.jpg";